export const REDUCER_NAME = "competitionSponsors";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONSPONSORS = `${REDUCER_NAME}/SET_COMPETITIONSPONSORS`;
export const RESET_COMPETITIONSPONSORS = `${REDUCER_NAME}/RESET_COMPETITIONSPONSORS`;
